module.exports = __webpack_public_path__ + "img/b317c2e.png";